
import { Navigation } from "@/components/Navigation";
import { Categories } from "@/components/Categories";
import { FeaturedPolls } from "@/components/FeaturedPolls";
import { Footer } from "@/components/Footer";
import { ConfirmationEmailAlert } from "@/components/ConfirmationEmailAlert";
// import { LiveActivity } from "@/components/LiveActivity";
import { Users, UserPlus, Trophy } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { useState } from "react";
import { Head } from "@/components/Head.tsx";
import { SEO } from "@/components/SEO.tsx";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import * as React from "react";

const Index = () => {
  const isMobile = useIsMobile();
  const isLoading = useState(false);
  const navigate = useNavigate();

  // Format number with commas
  const formatNumber = (num: number) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="min-h-screen bg-background">
      <SEO
          title="blankpoll - Gamified Poll Market"
          description="Vote, Play, Discover. Your Opinion Shapes the Future. Turn Opinions into Impact"
          type="website"
          name="blankpoll"
          imageUrl="/blankpoll-banner.jpg"
      />
      <Navigation />
      <Categories />
      <main className="pt-24 bg-background">
        {/* Confirmation Email Alert */}
        {/*<div className="max-w-7xl mx-auto px-4 mb-6">
          <ConfirmationEmailAlert />
        </div>*/}

        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-secondary dark:text-white">Featured Polls</h2>
          <p className="text-gray-600 dark:text-gray-300 mt-2">Discover our most popular and exciting poll events</p>
        </div>

        <FeaturedPolls />

        {/* Commented out Live Platform Activity */}
        {/*
        <div className="text-center mb-6 mt-12">
          <h2 className="text-2xl font-bold text-secondary dark:text-white">Live Platform Activity</h2>
          <p className="text-gray-600 dark:text-gray-300 mt-2">See what's happening on the platform right now</p>
        </div>

        <LiveActivity />
        */}
      </main>

      {/* Updated gradient section with new design */}
      <div className="w-full py-16 mt-16 bg-gradient-to-r from-[#088B6C] to-[#009E6B]">
        <div className="container mx-auto px-4">
          {/* Main content section */}
          <div className="flex flex-col items-center justify-center text-center">
            {/* Icon */}
            <Users className="h-12 w-12 mb-6 text-white" />

            {/* Main title - much larger */}
            <h2 className="font-bold text-4xl md:text-5xl lg:text-6xl text-white mb-8 leading-tight">
              Join millions of users and vote for the future
            </h2>

            {/* Single subtitle description */}
            <div className="max-w-4xl mb-12">
              <p className="text-white/90 text-lg md:text-xl">
                Join forces with like-minded voters in clans and compete in seasonal leagues to climb the ranks, earn exclusive rewards and showcase your voting expertise in our community-driven ecosystem.
              </p>
            </div>

            {/* Buttons with icons - side by side on mobile */}
            <div className="flex flex-row gap-4 w-full max-w-md">
              <Button
                variant="secondary"
                className="flex-1 bg-white/20 hover:bg-white/30 text-white border-white/30 hover:border-white/50"
                onClick={() => navigate('/clans')}
              >
                <UserPlus className="h-4 w-4 mr-2" />
                Join a Clan
              </Button>
              <Button
                variant="secondary"
                className="flex-1 bg-white/20 hover:bg-white/30 text-white border-white/30 hover:border-white/50"
                onClick={() => navigate('/leagues')}
              >
                <Trophy className="h-4 w-4 mr-2" />
                View Leagues
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Index;
